var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item-wrap"},[_vm._v(_vm._s(_vm.info)+" "),_c('i',{staticClass:"el-icon-circle-close delete-item",attrs:{"icon":"el-icon-delete"},on:{"click":_vm.deleteBlackItem}})])
}
var staticRenderFns = []

export { render, staticRenderFns }